






















import { Link } from "@/api/models";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class LinkSet extends Vue {
  @Prop({ default: "links" }) name: string;
  @Prop({ default: "main" }) refId: string;
  @Prop({ default: () => [] }) links: Array<Link>;

  randNum() {
    return Math.floor(Math.random() * 1000);
  }
}
